import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";
import AddSlack from "static/images/AddSlack.svg";
import { UnorderedList } from "./design/unorderdList";
import cx from "classnames";
import ToolTip from "./design/toolTip";
import classNames from "classnames";
import FloatingSlack from "static/images/FloatingSlack.svg";
import SubscribeSlack from "static/images/SubscribeSlack.svg";
import GreyInfo from "static/images/InfoGray.svg";
import NewSlack from "static/images/newSlack.svg";
import { Button } from "../components/DesignSystem/Button/Button";
import { SlackIntegrationConfirmModal } from "./SlackInegrationConfirmModal";
import { useModal } from "hooks/useModal";

const ToolTipContainer = () => {
  return (
    <ToolTip
      side="bottom"
      text={
        <div className="t-text-left">
          <h6>How it works?</h6>
          <UnorderedList className="t-m-0">
            <li className="t-mb-2">
              Receive chat notifications of all your unread messages on Slack
            </li>
            <li className="t-mb-2">
              Send a quick reply to the latest unread message by replying to the
              alert on Slack
            </li>
            <li className="t-mb-2">
              Never miss important messages on your tax deadlines and filings
            </li>
          </UnorderedList>
        </div>
      }
    >
      <img
        className="t-cursor-pointer"
        src={GreyInfo}
        alt="How slack connection works?"
      />
    </ToolTip>
  );
};

export const SlackIntegration = ({
  reverse,
  hideOnceAdded,
  floating,
  isChat,
}) => {
  const { authtoken } = useContext(authContext);
  const slackUrl = `${process.env.PUBLIC_SLACK_AUTH_URL}`;
  const isSlackConnected = authtoken.is_slack_added;
  const confirmModal = useModal();

  if (isSlackConnected && hideOnceAdded) {
    return null;
  }

  return (
    <div
      className={classNames("t-items-center", {
        floatingSlack: floating,
      })}
    >
      {!floating && (
        <div
          className={cx("t-w-full t-flex", {
            "t-hidden": isSlackConnected,
            "t-order-1": !reverse,
            "t-order-2 t-justify-end": reverse,
          })}
        >
          <ToolTipContainer />
        </div>
      )}

      <span
        className={cx("t-relative t-w-full", {
          "t-order-2": !reverse,
          "t-order-1": reverse,
        })}
      >
        <>
          {!floating ? (
            <a href={slackUrl} className="all:unset t-w-full">
              {isSlackConnected ? (
                <div className="t-flex t-justify-between t-items-center t-border t-border-solid t-border-neutral-0 t-p-3 t-gap-2 t-w-full t-rounded t-cursor-pointer">
                  <div className="t-flex t-gap-2">
                    <img
                      alt="Add to Slack"
                      className="t-w-5 t-h-5"
                      src={SubscribeSlack}
                    />
                    <div className="t-text-body t-text-text-100">
                      Update Slack
                    </div>
                  </div>
                  <ToolTipContainer />
                </div>
              ) : (
                <img
                  alt="Add to Slack"
                  style={{ height: "40px" }}
                  className="t-cursor-pointer"
                  src={AddSlack}
                />
              )}
            </a>
          ) : (
            !isSlackConnected && (
              <>
                {!isChat ? (
                  <img
                    alt="Add to Slack"
                    className="t-h-8 t-cursor-pointer"
                    src={FloatingSlack}
                  />
                ) : (
                  <ToolTip side="right" text="Get alerts on Slack">
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        confirmModal.open();
                      }}
                      customType="secondary"
                      size="small"
                    >
                      <div className="t-flex t-items-center t-gap-1.5 t-h-3">
                        <img
                          alt="Add to Slack"
                          className="t-h-4 t-w-4 t-cursor-pointer"
                          src={NewSlack}
                        />
                        <div className="t-text-subtext-sm t-text-text-60">
                          Connect
                        </div>
                      </div>
                    </Button>
                  </ToolTip>
                )}
              </>
            )
          )}
        </>
      </span>
      <SlackIntegrationConfirmModal
        show={confirmModal.isOpen}
        onOpenChange={() => confirmModal.close()}
        slackUrl={slackUrl}
      />
    </div>
  );
};
